import { motion } from "framer-motion";
import HeroVisual from "./HeroVisual";

const ease = [0.22, 1, 0.36, 1];

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden pt-44 sm:pt-36 md:pt-40 pb-8 md:pb-10"
    >
      {/* Subtle background layers */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-40 -left-40 h-[520px] w-[520px] rounded-full bg-[#0F766E]/[0.04] blur-3xl" />
        <div className="absolute top-24 -right-40 h-[480px] w-[480px] rounded-full bg-[#C9A227]/[0.05] blur-3xl" />
      </div>

      <div className="mx-auto max-w-7xl px-6 md:px-10 relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Creative visual */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, ease, delay: 0.1 }}
            className="order-2 lg:order-1"
            data-testid="hero-visual"
          >
            <HeroVisual />
          </motion.div>

          {/* Main Content */}
          <div className="order-1 lg:order-2 w-full">
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease }}
              className="inline-flex items-center gap-2 text-[11px] tracking-[0.14em] uppercase text-[#C9A227]"
              data-testid="hero-eyebrow"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-[#C9A227]" />
              One Partner. Every Financial Solution.
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease, delay: 0.05 }}
               className="mt-8 font-display text-[26px] sm:text-3xl md:text-4xl lg:text-5xl leading-[1.08] tracking-tight text-[#0F172A]"
              data-testid="hero-headline"
            >
              Financial Solutions,
              <br />
              <span className="italic text-[#0F172A]/95">
                Simplified<span className="text-[#C9A227]">.</span>
              </span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease, delay: 0.18 }}
              className="mt-7 max-w-xl text-[16px] md:text-[17px] leading-[1.7] text-[#475569]"
              data-testid="hero-subhead"
            >
              From investments and insurance to loans and tax filing,
              Vish Capital brings every financial service together under one
              trusted partner — helping you build wealth, protect your future,
              and reach your goals with confidence.
            </motion.p>

          </div>
        </div>
      </div>
    </section>
  );
}